import { ResourceConsumptionBaseState } from './resource-consumption-base.model';
import * as ResourceConsumptionBaseActions from './resource-consumption-base.action';
import {
  transformResourceConsumptionGroupData,
  getResourceConsumptionGroupSubscriptionName
} from './resource-consumption-base.utils';
import {
  createTimeSeriesReducer,
  createStandardTimeSeriesReducerConfig
} from '../shared';

export const initialState = new ResourceConsumptionBaseState();

export const resourceConsumptionBaseReducer = createTimeSeriesReducer(
  createStandardTimeSeriesReducerConfig({
    initialState,
    trackActionType: ResourceConsumptionBaseActions.trackResourceConsumptionGroupItem,
    prefillActionType: ResourceConsumptionBaseActions.resourceConsumptionGroupPrefillData,
    successActionType: ResourceConsumptionBaseActions.resourceConsumptionGroupSuccess,
    updateActionType: ResourceConsumptionBaseActions.resourceConsumptionGroupUpdate,
    getSubscriptionName: (item: any) => getResourceConsumptionGroupSubscriptionName(
      item.data?.groupBy || item.payload?.groupBy,
      item.data?.groupRange?.timeGroupBy || item.payload?.groupRange?.timeGroupBy,
      item.data?.metricId || item.payload?.metricId,
      item.data?.projectId || item.payload?.projectId,
      item.data?.groupRange?.key || item.payload?.groupRange?.key
    ),
    transformData: transformResourceConsumptionGroupData
  })
);